import { differenceInYears } from 'date-fns';

export function calculatePatientAge(birthdate: Date) {
  return differenceInYears(new Date(), new Date(birthdate));
}
